import { render, staticRenderFns } from "./DevolucionRecepcionModalComponent.vue?vue&type=template&id=8b745fa4&"
import script from "./DevolucionRecepcionModalComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionRecepcionModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports